import React from 'react';
import { IIconProps } from '../interfaces';

const PhoneIcon = (props: IIconProps) => {
  return (
      <svg
          width={ props.width }
          height={ props.width }
          viewBox="0 0 13 13"
          className={ props.classes }
          xmlns="http://www.w3.org/2000/svg"><path d="M5.342 7.657a10.972 10.972 0 0 1-1.524-1.902.73.73 0 0 1 .005-.802l.62-.958a.722.722 0 0 0 .072-.666L3.448.484A.741.741 0 0 0 2.35.119L.86 1.07a1.833 1.833 0 0 0-.808 2 13.19 13.19 0 0 0 3.57 6.306 13.194 13.194 0 0 0 6.307 3.57 1.833 1.833 0 0 0 2-.807l.951-1.49a.741.741 0 0 0-.365-1.097L9.671 8.484a.725.725 0 0 0-.666.072l-.958.62a.73.73 0 0 1-.803.005 10.95 10.95 0 0 1-1.902-1.524z" fill={ props.color }/></svg>
  )
};

export default PhoneIcon;
